var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_call",
    "data-name": "icon call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 30,
    height: 30,
    rx: 5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "telephone-fill",
    d: "M1.885.511a1.745,1.745,0,0,1,2.61.163L6.29,2.98a1.744,1.744,0,0,1,.315,1.494l-.547,2.19a.678.678,0,0,0,.178.643L8.693,9.764a.678.678,0,0,0,.644.178L11.526,9.4a1.745,1.745,0,0,1,1.494.315L15.326,11.5a1.745,1.745,0,0,1,.163,2.611l-1.034,1.034a2.777,2.777,0,0,1-2.877.7,18.634,18.634,0,0,1-7.01-4.42A18.634,18.634,0,0,1,.148,4.422a2.78,2.78,0,0,1,.7-2.877Z",
    transform: "translate(7 7)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCall);
export default __webpack_public_path__ + "static/media/ic_call.30aaceaa780d02f9d1b2c45ad8e28552.svg";
export { ForwardRef as ReactComponent };